import { supabase } from '@/lib/supabase';

// WebSocket del Chat (/api/chat/ws): auth por primer frame, reconexión con backoff, latido bidireccional y vigilante de conexión muerta.
const WS_URL = `${process.env.REACT_APP_BACKEND_URL.replace(/^http/, 'ws')}/api/chat/ws`;
const CLIENT_PING_MS = 20000; // el servidor también manda ping cada 20 s
const STALE_MS = 50000; // sin ningún frame en este lapso = conexión medio abierta → reconectar
let ws = null; let retry = null; let attempt = 0; let users = 0; let lastTyping = 0; let beat = null; let selfId = null; let lastSeen = 0;
let status = 'offline'; // offline | connecting | live
const handlers = new Set(); const statusHandlers = new Set();

const setStatus = (s) => { if (status === s) return; status = s; statusHandlers.forEach((f) => f(s)); };
const schedule = () => { if (!users || retry) return; const delay = Math.min(30000, 1000 * 2 ** attempt); attempt += 1; retry = setTimeout(() => { retry = null; open(); }, delay); };

const open = async () => {
  if (!users || (ws && ws.readyState <= 1)) return;
  setStatus('connecting');
  let token = null;
  try { const { data: { session } } = await supabase.auth.getSession(); token = session?.access_token || null; } catch { /* sin sesión */ }
  if (!token || !users) { schedule(); return; }
  const sock = new WebSocket(WS_URL); ws = sock; lastSeen = Date.now();
  sock.onopen = () => sock.send(JSON.stringify({ type: 'auth', token }));
  sock.onmessage = (e) => {
    lastSeen = Date.now();
    let ev; try { ev = JSON.parse(e.data); } catch { return; }
    if (ev.type === 'ready') { attempt = 0; selfId = ev.user_id || null; setStatus('live'); return; }
    if (ev.type === 'ping') { if (sock.readyState === 1) sock.send(JSON.stringify({ type: 'pong' })); return; }
    if (ev.type === 'pong' || ev.type === 'error') return;
    handlers.forEach((f) => f(ev));
  };
  sock.onclose = () => { if (ws === sock) { ws = null; setStatus('offline'); schedule(); } };
  sock.onerror = () => sock.close();
};

const send = (obj) => { if (ws && ws.readyState === 1 && status === 'live') ws.send(JSON.stringify(obj)); };
// Reconexión inmediata (sin backoff): al detectar conexión muerta o al volver a la pestaña
const reconnectNow = () => {
  clearTimeout(retry); retry = null; attempt = 0;
  const sock = ws; ws = null;
  if (sock) { try { sock.close(); } catch { /* ya cerrado */ } }
  setStatus('offline'); open();
};
const tick = () => {
  if (!users) return;
  if (ws && ws.readyState === 1) {
    if (Date.now() - lastSeen > STALE_MS) { reconnectNow(); return; }
    send({ type: 'ping' });
  } else if (!ws && !retry) open();
};
const onVisible = () => { if (document.visibilityState !== 'visible' || !users) return; if (!ws || ws.readyState !== 1 || Date.now() - lastSeen > CLIENT_PING_MS * 1.5) reconnectNow(); };
const startBeat = () => { clearInterval(beat); beat = setInterval(tick, CLIENT_PING_MS); document.addEventListener('visibilitychange', onVisible); window.addEventListener('online', reconnectNow); };
const stopBeat = () => { clearInterval(beat); beat = null; document.removeEventListener('visibilitychange', onVisible); window.removeEventListener('online', reconnectNow); };

export const chatSocket = {
  connect() { users += 1; if (users === 1) { startBeat(); open(); } },
  disconnect() {
    users = Math.max(0, users - 1); if (users) return;
    clearTimeout(retry); retry = null; stopBeat(); attempt = 0;
    const sock = ws; ws = null; if (sock) sock.close(); setStatus('offline');
  },
  on(fn) { handlers.add(fn); return () => handlers.delete(fn); },
  onStatus(fn) { statusHandlers.add(fn); fn(status); return () => statusHandlers.delete(fn); },
  isLive: () => status === 'live',
  selfId: () => selfId,
  typing(convId) { const now = Date.now(); if (now - lastTyping < 2500) return; lastTyping = now; send({ type: 'typing', conversation_id: convId || null }); },
};
